import { Component, computed, input, output } from '@angular/core';
import type { EChartsCoreOption, ECElementEvent } from 'echarts/core';
import { NgxEchartsDirective } from 'ngx-echarts';
import { COMMON_IMPORTS } from '../../../../Shared/common-imports';
import { ChartDatum } from '../../../models/report-dashboard.types';

@Component({
  selector: 'app-report-chart-card',
  standalone: true,
  imports: [COMMON_IMPORTS, NgxEchartsDirective],
  templateUrl: './report-chart-card.component.html',
  styleUrl: './report-chart-card.component.scss',
})
export class ReportChartCardComponent {
  readonly titleKey = input.required<string>();
  readonly options = input.required<EChartsCoreOption | null>();

  readonly segmentClick = output<string>();

  readonly hasData = computed(() => this.optionsHaveData(this.options()));

  onChartClick(event: ECElementEvent): void {
    const key = (event.data as ChartDatum | undefined)?.key;
    if (key) this.segmentClick.emit(key);
  }

  private optionsHaveData(options: EChartsCoreOption | null): boolean {
    if (!options) return false;
    const series = (options as Record<string, unknown>)['series'];
    const seriesList = Array.isArray(series) ? series : series ? [series] : [];
    return seriesList.some(entry => Array.isArray((entry as Record<string, unknown>)?.['data']) && ((entry as { data: unknown[] }).data.length > 0));
  }
}
